// "a" or "an" for the word that follows, by how it is usually said rather
// than how it is spelled: "an EXGF Pass scene", "an 18YearsOld scene", but
// "a EuroHumpers scene". It's a heuristic for site and series names, not a
// full pronunciation model: an initialism read letter by letter that starts
// with a consonant letter said with a vowel sound ("an MMA scene") still gets
// "a", since acronyms read as words ("a MILF scene") are just as common.

// Vowel letters that start with a "y"/"w" sound: "a EuroHumpers", "a one-off".
const CONSONANT_SOUND_VOWEL =
  /^(eu|ewe|uni|use|usa|usu|uti|ura|ure|uro|one(?![a-z]))/i
// Silent "h": "an hour", "an honest".
const VOWEL_SOUND_H = /^(hour|honest|honou?r|heir)/i

export const indefiniteArticle = (word) => {
  const text = String(word ?? "").trim()

  // Numbers: "an 8K", "an 80s", "an 11", "an 18YearsOld". Only 11 and 18 as
  // whole leading numbers (eleven, eighteen); "a 180" and "a 1080p" are said
  // "a one-…". Years like "1800s" ("eighteen hundreds") are not handled.
  const number = text.match(/^\d+/)?.[0]
  if (number) {
    return number.startsWith("8") || number === "11" || number === "18"
      ? "an"
      : "a"
  }

  if (CONSONANT_SOUND_VOWEL.test(text)) return "a"
  if (VOWEL_SOUND_H.test(text)) return "an"
  return /^[aeiou]/i.test(text) ? "an" : "a"
}

// "an EXGF Pass", "a Tiny4K".
export const withIndefiniteArticle = (word) =>
  `${indefiniteArticle(word)} ${word}`
